import { Link } from 'react-router-dom'

function AudienceSplit() {
    return (
        <div className="audience-split">
            <div className="audience-split__panel audience-split__panel--brands">
                <div className="audience-split__top">
                    <span className="audience-split__label">For Brands</span>
                    <span className="audience-split__index">01</span>
                </div>
                <h3 className="audience-split__title">I want to grow my brand</h3>
                <p className="audience-split__copy">
                    Fund a campaign, set per-interaction prices, only pay for verified engagement.
                </p>
                <Link to="/brands" className="audience-split__cta">
                    See how brands use PostPaid <span aria-hidden="true" className="audience-split__arrow">→</span>
                </Link>
            </div>

            <div className="audience-split__panel audience-split__panel--creators">
                <div className="audience-split__top">
                    <span className="audience-split__label">For Creators</span>
                    <span className="audience-split__index">02</span>
                </div>
                <h3 className="audience-split__title">I want to get paid for my content</h3>
                <p className="audience-split__copy">
                    Active accounts on Instagram or TikTok. Start earning per verified interaction.
                </p>
                <Link to="/creators" className="audience-split__cta">
                    See how creators get paid <span aria-hidden="true" className="audience-split__arrow">→</span>
                </Link>
            </div>
        </div>
    )
}

export default AudienceSplit
